import {Component, Input, OnInit, SimpleChanges, OnChanges, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from "../../../visit-context";
import {
  HarbourDuesDeclaration,
  HarbourDuesLogItem
} from "@portbase/bezoekschip-service-typescriptmodels";
import {ComparatorChain} from "../../../../common/comparator-chain";

@Component({
  selector: 'app-harbour-dues-history-amsterdam',
  templateUrl: './harbour-dues-history-amsterdam.component.html',
  styleUrls: ['./harbour-dues-history-amsterdam.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HarbourDuesHistoryAmsterdamComponent implements OnInit, OnChanges {

  context = VisitContext;
  items: HarbourDuesLogItem[] = [];
  reverseOrder = true;
  @Input() declaration: HarbourDuesDeclaration;

  private logComparator = new ComparatorChain("timestamp").compare;

  ngOnInit(): void {
    if (this.declaration != null) {
      this.getLogItems()
    }
  }

  getLogItems() {
    this.items = this.declaration?.logItems?.sort(this.logComparator);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['declaration']) {
      this.getLogItems()
    }
  }


  cast = (item: HarbourDuesLogItem): HarbourDuesLogItem => item;

  toggleOrder() {
    this.reverseOrder = !this.reverseOrder;
  }
}
